import { getEnv } from 'lib/configUtils';


/*
 * App naming
 */

export const CRA_PREFIX = 'REACT_APP_JP_';
export const WIDGET_REACT_ID = getEnv("WIDGET_REACT_ID", "otrl-jp-widget-v1");
export const VERSION = getEnv("VERSION", "3.3.0 (14062021) manually set");
export const UTM_MEDIUM = getEnv("UTM_MEDIUM", "OnTrack_Retail_Widgets");


/*
 * UI
 */

export const WIDGET_MODES = {
  IFRAME: 'iframe',
  SCRIPT: 'script'
};

export const LAYOUT_BREAKPOINTS = {
  TABLET_XS: 767,
  MOBILE: 1169, // match with $desktop-bp in variables.scss
  DESKTOP: 100000,
};

export const TabsStyle = {
  PANEL: 'PANEL',
  BUTTON: 'BUTTON'
};

export const TabsType = {
  TICKETS: 'TICKETS',
  SEASON: 'SEASON',
  OTHER: 'OTHER',
  FAVOURITES: 'FAVOURITES'
};

// It's needed for identifying where JP Widget is used
export const CONTEXT = {
  BROCHURE_SITE: 'BROCHURE_SITE',
  BOOKING_ENGINE: 'BOOKING_ENGINE',
}

/*
 * Component constants
 */

export const MIN_DATES = {
  DAY_SAVE: { days: 3 },
  ROVERS: { days: 3 },
};

// No. of business days
export const MIN_POSTAL_DELIVERY_DATES = {
  FIRST_CLASS: 6,
  ROYAL_SIGNED: 4,
  ROYAL_SPECIAL: 2,
};

export const MAX_DATES = {
  DAY_SAVE: { weeks: 12 },
  ROVERS: { weeks: 12 },
  SINGLES: { days: 84 },
  SEASON: { months: 1 },
  SEASON_CUSTOM_LENGTH: { years: 1 },
};

export const FulfilmentType = {
  E_TICKET: '00006',
  PRINT_AT_HOME: '00003',
  COLLECTION: '00005',
  POSTAL: '00009',
  SMARTCARD: '00001',
};

export const PostalDeliveryMethodId = {
  FIRST_CLASS: '4OAzk7ZIZWbhbkwzKI0N3S2iB5I=',
  ROYAL_SIGNED: 'RlZAQLI0eVJZnAGRWaB66bqd24Q=',
  ROYAL_SPECIAL: 'WBGBXDJS9ybLKmKSRPJemwzRQtw=',
};

export const FavouriteSeasonExpiringSoonThresholdDays = 7;


/*
 * Booking Engine authentication
 */

export const LOGIN_PATH = '/widget-auth/login';

export const HAND_OFF_PATH = '/hand-off/fare';

export const LOCALHOST_BOOKING_ENGINE_ENV = 'stage';

export const COOKIE_NAMES = {
  CUSTOMER_TOKEN: 'Customer-Token',
  LAST_USER_ACTIVITY: 'last-user-activity'
};

export const SESSION_TIMEOUT_MINS = 30;


/*
 * CSS prefix
 */

export const CSS_COMPONENT_PREFIX = 'otrl-jp__';


/*
 * Configuration options
 */

export const API_ACCESS_TOKEN = {
  default: '8gh2w38ho43o83hw48o4hg8h4g8',
  stage: '86512cad76131783f5dae4346ddc3fb39f6f7c0f74b3039bff70ca4015ade034',
  prod: 'otrl|a6af56be1691ac2929898c9f68c4b49a0a2d930849770dba976be5d792a'
}

export const UTM_PARAMS_EXCLUDED_HOSTNAMES = [
  /southeasternrailway.co.uk/,
  /southernrailway.com/,
  /thameslinkrailway.com/,
  /greatnorthernrail.com/,
  /gatwickexpress.com/,
  /tpexpress.co.uk/,
];

export const FRANCHISES = {
  none: "none",
  southeastern: "southeastern",
  gtr: "gtr",
  transpennine: 'transpennine',
};

export const BRANDS = {
  SE: 'southeastern',
  TL: 'thameslink',
  SN: 'southern',
  GN: 'greatnorthern',
  GX: 'gatwick',
  TH: 'trainhugger',
  TB: 'ticketyboo',
  TP: 'transpennine',
};

export const BRAND_DOMAINS = {
  SE: 'southeasternrailway.co.uk',
  TL: 'thameslinkrailway.com',
  SN: 'southernrailway.com',
  GN: 'greatnorthernrail.com',
  GX: 'gatwickexpress.com',
  TH: 'trainhugger.com',
  TB: 'www.myticketyboo.com',
  TP: 'www.tpexpress.co.uk',
};

export const DEFAULT_OPTIONS = {
  id: null,
  brand: null,
  redirectUrl: 'https://southeastern.stage.otrl.io',
  apiUrl: 'https://api-southeastern.stage.otrl.io',
  apiAccessToken: null,
  stylesheetUrl: 'null',
  redirectEnvironment: 'production',
  enablePromoDiscount: false,
  vertical: false,
  searchCallBack: null,
  from: null,
  to: null,
  defaultValues: null,
  tabsStyle: TabsStyle.PANEL,
  activeTab: TabsType.TICKETS,
  disableBackground: false,
  disabledTabs: [TabsType.OTHER, TabsType.FAVOURITES].join(','),
  googleTagManagerId: null,
  dataLayerName: null,
  disabledRailcards: '',
  popularStationsList: FRANCHISES.none,
  utmCampaign: null,
  utmContent: null,
  enableBestFareFinderAndRecentOrders: false,
  utmMedium: null,
  utmSource: null,
  enableModalHeightResize: false,
  gatwickRoutes: false,
  context: CONTEXT.BROCHURE_SITE,
};

export const FEATURE_FLAGS = {
  darkMode: false,
  closeModalWithBackButton: false,
  hideNavigation: false,
  hideSubNavigation: false,
  hidePromotionalText: false,
  enableDaySave: false,
  enableRoversRangers: true,
  enableKentRover: false,
  enableSmartCarnet: false,
  enableTransPennineRover: false,
  enableFlexi: true,
  gatwickRoutes: false,
};

export const QUERY_PARAM_NAMES = [
  "id",
  "redirectUrl",
  "stylesheetUrl",
  "apiUrl",
  "vertical",
  "darkMode",
  "gatwickRoutes",
  "from",
  "to",
  "tabsStyle",
  "activeTab",
  "hideNavigation",
  "hideSubNavigation",
  "disableBackground",
  "hidePromotionalText",
  "enableDaySave",
  "enableRoversRangers",
  "enableSmartCarnet",
  "enableFlexi",
  "disabledTabs",
  "googleTagManagerId",
  "dataLayerName",
  "disabledRailcards",
  "enableModalHeightResize",
  "popularStationsList",
  "enableKentRover",
  "enableTransPennineRover",
  "utmCampaign",
  "utmContent",
  "utmMedium",
  "utmSource",
  "utm_campaign",
  "utm_content",
  "utm_medium",
  "utm_source",
];
